module.exports = __webpack_public_path__ + "img/bgd3.66ca6db1.png";